import { useState } from 'react';

export const useForm = ( initialForm = {} ) => {
  
  const [ formState, setFormState ] = useState( initialForm );

  const onInputChange = ({ target }) => {
    let { name, value } = target;

    if (( name === "filiacion_cultural_id" ||
          name === "tipo_material_id" ||
          name === "periodo_id" ||
          name === "tipo_objeto_id") &&
          value === "Seleccionar") {
      value = 0
    }

    if (( name === "codigomuseo" ||
          name === "proveniencia_codigo") &&
          value === "Seleccionar") {
      value = ""
    }
    setFormState({
      ...formState,
      [ name ]: value
    });
  }

  const setFormValue = ( form ) => {
    setFormState( form );
  };
  
  const onResetForm = () => {
    setFormState( initialForm );
  }

  return {
    ...formState,
    formState,
    onInputChange,
    onResetForm,
    setFormValue,
  }
}